import { FrameContent, FrameHeading, Lesson, Text } from "./TopicsStyle"
import { TopicData } from "./TopicsData"
import { useDispatch, useSelector } from "react-redux";
import { guestAccessAttempt } from "../../../features/guest/guestSlice";
import { listening } from "../../../i18n/08_listening";

// const lessons = Array.from({ length: 30 }, (_, i) => `Lesson ${i + 1}`);

const Topics = ({ isLessonUnlocked, handleTopicClick, isGuest }) => {
    const lang = useSelector(state => state. lang.lang)
    const t = listening[lang]

    const dispatch = useDispatch()
  return (
    <FrameContent>
      <FrameHeading>{t.listOfTopics}</FrameHeading>
      {TopicData.map((value, index) => {
        const lessonNumber = index + 1
        const unlocked = isLessonUnlocked ? isLessonUnlocked(lessonNumber) : true

        const handleClick = () => {
          if (isGuest) {
            dispatch(guestAccessAttempt());
            return;
          }
          if (!unlocked) return
          handleTopicClick(lessonNumber)
        }


        return (

          <Text
            key={index}
            onClick={handleClick}
            data-locked={unlocked ? "false" : "true"}
          >
            <Lesson>
              Lesson {index + 1}.
            </Lesson>
            {value.topic}
          </Text>
        )
      })}
    </FrameContent>
  )
}

export default Topics